import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";

export default function PublicRoute({ children }) {
  const { auth } = useContext(AuthContext);

  if (auth?.isAuthenticated) {
    const role = auth?.user?.role;
    return <Navigate to={role === "admin" ? "/admin/dashboard" : "/client/dashboard"} replace />;
  }
  return children;
}
